import Scale from '../views/scale/index.vue';
import Survey from '../views/survey/index.vue';
import Question from '../views/question/index.vue';
import Warning from '../views/warning/index.vue';
import Login from '../views/login/index.vue';
export default [
	{
		path: '/login',
		component: Login,
		meta: {
			title: '登录'
		}
	},
	//详情
	{
		path: '/scale/answer', //开始测评
		name: 'Answer',
		component: () => import('../views/scale/scaleList/answer.vue')
	},
	//量表测评
	{
		path: '/scale',
		component: Scale,
		meta: {
			title: '量表测评'
		},
		children: [
			{
				path: '/', //待测评量表
				name: 'ScaleList',
				component: () => import('../views/scale/scaleList')
			},
			{
				path: 'questionBack', //量表题库
				name: 'QuestionBack',
				component: () => import('../views/scale/questionBack')
			},
			{
				path: 'publish', //发布量表
				name: 'Publish',
				component: () => import('../views/scale/publish/publish.vue')
			},
			{
				path: 'code', //发布量表
				name: 'Code',
				component: () => import('../views/scale/code')
			},
			{
				path: 'scaleResult', //量表结果
				name: 'ScaleResult',
				component: () => import('../views/scale/result/scale.vue')
			},
			{
				path: 'teamResult', //团体结果
				name: 'TeamResult',
				component: () => import('../views/scale/result/team.vue')
			}
		]
	},
	//详情
	{
		path: '/survey/topic', //开始测评
		name: 'SurveyTopic',
		component: () => import('../views/survey/surveyList/topic.vue')
	},
	{
		path: '/survey/answer', //开始测评
		name: 'SurveyAnswer',
		component: () => import('../views/survey/surveyList/answer.vue')
	},
	//普查测评
	{
		path: '/survey',
		component: Survey,
		meta: {
			title: '普查测评'
		},
		children: [
			{
				path: '/', //待测评
				name: 'surveyList',
				component: () => import('../views/survey/surveyList/index.vue')
			},
			{
				path: 'publish', //发布测评
				name: 'surveyPublish',
				component: () => import('../views/survey/publish/publish.vue')
			},
			{
				path: 'code', //发布测评
				name: 'surveyCode',
				component: () => import('../views/survey/code/index.vue')
			},
			{
				path: 'surveyResult', //发布测评
				name: 'surveyResult',
				component: () => import('../views/survey/result/index.vue')
			}
		]
	},
	//详情
	{
		path: '/question/topic', //开始测评
		name: 'QuestionTopic',
		component: () => import('../views/question/questionList/topic.vue')
	},
	{
		path: '/question/answer', //开始测评
		name: 'QuestionAnswer',
		component: () => import('../views/question/questionList/answer.vue')
	},
	//问卷测评
	{
		path: '/question',
		component: Question,
		meta: {
			title: '问卷测评'
		},
		children: [
			{
				path: '/', //待测评问卷
				name: 'questionList',
				component: () => import('../views/question/questionList/index.vue')
			},
			{
				path: 'back', //问卷题库
				name: 'Back',
				component: () => import('../views/question/questionBack/index.vue')
			},
			{
				path: 'publish', //发布问卷
				name: 'QuestionPublish',
				component: () => import('../views/question/publish/publish.vue')
			},
			{
				path: 'code', //扫码测评
				name: 'QuestionCode',
				component: () => import('../views/question/code/index.vue')
			},
			{
				path: 'result', //问卷结果
				name: 'QuestionResult',
				component: () => import('../views/question/result/index.vue')
			}
		]
	},
	{
		path: '/warning',
		component: Warning,
		meta: {
			title: '预警结果'
		},
		children: [
			{
				path: 'list', //结果列表
				name: 'WarningList',
				component: () => import('../views/warning/warning.vue')
			}
		]
	}
];
